import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

// ✅ FIXED: Use hardcoded API URL (same as other working components)
const API_BASE_URL = "https://final-project-5ar7.onrender.com";
console.log('🌐 METATRADER API_BASE_URL:', API_BASE_URL); // ✅ Debug log

const MetaTraderLogin = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [credentials, setCredentials] = useState({
    login: '',
    password: '',
    server: 'stoneforex-Live'
  });
  const [userAccounts, setUserAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('🔍 MetaTrader Login - Auth user:', user);
    if (!user) {
      console.log('❌ No user in auth context, redirecting to login');
      navigate('/login');
      return;
    }
    fetchUserAccounts();
  }, [user, navigate]);

  const fetchUserAccounts = async () => {
    if (!user?.id) {
      console.error('❌ No user ID available');
      setError('User session not found');
      return;
    }

    try {
      console.log('🔄 Fetching trading accounts for user:', user.id);
      console.log('📍 Using API URL:', `${API_BASE_URL}/api/admin/public/user-trading-accounts/${user.id}`);
      
      // ✅ FIXED: Use correct API URL
      const response = await axios.get(`${API_BASE_URL}/api/admin/public/user-trading-accounts/${user.id}`);
      console.log('📊 Trading accounts response:', response.data);
      
      const approvedAccounts = response.data.filter(account => 
        account.adminStatus === 'approved'
      );
      
      console.log('✅ Approved accounts for MetaTrader:', approvedAccounts);
      setUserAccounts(approvedAccounts);
      
      if (approvedAccounts.length === 0) {
        setError('No approved trading accounts found. Please create and get approval for a trading account first.');
      }
      
    } catch (error) {
      console.error('❌ Error fetching accounts:', error);
      console.error('❌ Error details:', error.response?.data);
      setError('Failed to load trading accounts. Please try again.');
    }
  };

 const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    console.log('🔑 Attempting MetaTrader login...');
    
    const account = userAccounts.find(acc => acc.accountId.toString() === credentials.login);
    
    if (!account) {
      setError('Account not found');
      setLoading(false);
      return;
    }

    console.log('📋 Selected account for MetaTrader:', account);

    // ✅ SMART BYPASS: Check if this is a development account
    if (account.adminNotes?.includes('Auto-created for localhost development')) {
      console.log('🌱 Development account detected - bypassing password verification');
      console.log('✅ Development account login - proceeding directly to platform');
      
      // ✅ Save complete account data for MetaTrader platform
      const accountDataForMT = {
        accountId: account.accountId,
        mainPassword: account.mainPassword,
        investorPassword: account.investorPassword,
        server: account.server,
        group: account.group,
        balance: parseFloat(account.balance) || 0,
        equity: parseFloat(account.equity) || parseFloat(account.balance) || 0,
        margin: parseFloat(account.margin) || 0,
        freeMargin: parseFloat(account.freeMargin) || parseFloat(account.equity) || parseFloat(account.balance) || 0,
        leverage: account.leverage,
        adminStatus: account.adminStatus,
        userId: account.userId,
        // ✅ Mark as development account
        isDevelopmentAccount: true
      };
      
      localStorage.setItem('activeTradingAccount', JSON.stringify(accountDataForMT));
      console.log('✅ Development account data saved to localStorage:', accountDataForMT);
      console.log('🚀 Navigating directly to MetaTrader platform...');
      navigate('/metatrader-platform');
      return;
    }

    // ✅ PRODUCTION: Verify against TRADING ACCOUNT MAIN PASSWORD
    console.log('🔐 Production account detected - verifying trading account password...');
    console.log('🔍 Entered password:', credentials.password);
    console.log('🔍 Account mainPassword:', account.mainPassword);
    
    // ✅ Compare entered password with trading account's mainPassword
    if (credentials.password === account.mainPassword) {
      console.log('✅ Trading account password verified successfully!');
      
      // ✅ Save complete account data for production account
      const accountDataForMT = {
        accountId: account.accountId,
        mainPassword: account.mainPassword,
        investorPassword: account.investorPassword,
        server: account.server,
        group: account.group,
        balance: parseFloat(account.balance) || 0,
        equity: parseFloat(account.equity) || parseFloat(account.balance) || 0,
        margin: parseFloat(account.margin) || 0,
        freeMargin: parseFloat(account.freeMargin) || parseFloat(account.equity) || parseFloat(account.balance) || 0,
        leverage: account.leverage,
        adminStatus: account.adminStatus,
        userId: account.userId,
        isDevelopmentAccount: false
      };
      
      localStorage.setItem('activeTradingAccount', JSON.stringify(accountDataForMT));
      console.log('✅ Production account data saved to localStorage:', accountDataForMT);
      console.log('✅ MetaTrader login successful, navigating to platform');
      navigate('/metatrader-platform');
    } else {
      console.log('❌ Password mismatch!');
      console.log('❌ Expected:', account.mainPassword);
      console.log('❌ Received:', credentials.password);
      setError('Invalid trading account password');
    }
    
  } catch (error) {
    console.error('❌ MetaTrader login error:', error);
    console.error('❌ Error response:', error.response?.data);
    setError('Login failed. Please try again.');
  } finally {
    setLoading(false);
  }
};


  const handleCreateAccount = () => {
    navigate('/dashboard');
  };

  if (!user) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        width: '400px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden'
      }}>
        {/* Blue Header */}
        <div style={{
          backgroundColor: '#4285f4',
          color: 'white',
          padding: '16px 24px',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: '500'
        }}>
          Connect to StoneForex Server
        </div>

        {/* Main Form Content */}
        <div style={{ padding: '32px 24px' }}>
          <h2 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: '#333',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            Connect to account
          </h2>
          
          {error && (
            <div style={{
              backgroundColor: '#ffeaea',
              border: '1px solid #ffcdd2',
              color: '#d32f2f',
              padding: '12px 16px',
              borderRadius: '4px',
              marginBottom: '16px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          {/* ✅ ADD: Debug info for development */}
          {userAccounts.length === 0 && !loading && !error && (
            <div style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              color: '#856404',
              padding: '12px 16px',
              borderRadius: '4px',
              marginBottom: '16px',
              fontSize: '14px'
            }}>
              🔍 No trading accounts found. Please create a trading account first.
            </div>
          )}

          <form onSubmit={handleLogin}>
            {/* Login Field */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#555',
                marginBottom: '6px'
              }}>
                Login ({userAccounts.length} accounts available)
              </label>
              <select
                value={credentials.login}
                onChange={(e) => setCredentials({...credentials, login: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: '#fff8e1',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border-color 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#4285f4'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
                required
              >
                <option value="">Select your trading account</option>
                {userAccounts.map(account => (
                  <option key={account._id} value={account.accountId}>
                    {account.accountId} - Balance: ${parseFloat(account.balance).toLocaleString()}
                    {account.adminNotes?.includes('Auto-created for localhost development') ? ' (DEV)' : ''}
                  </option>
                ))}
              </select>
            </div>

            {/* Password Field - Show only for non-dev accounts */}
            {credentials.login && !userAccounts.find(acc => acc.accountId.toString() === credentials.login)?.adminNotes?.includes('Auto-created for localhost development') && (
              <div style={{ marginBottom: '16px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#555',
                  marginBottom: '6px'
                }}>
                  Password
                </label>
                <input
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    backgroundColor: '#fff8e1',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#4285f4'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                  placeholder="••••••••"
                  required
                />
              </div>
            )}

            {/* Development Account Notice */}
            {credentials.login && userAccounts.find(acc => acc.accountId.toString() === credentials.login)?.adminNotes?.includes('Auto-created for localhost development') && (
              <div style={{
                backgroundColor: '#e8f5e8',
                border: '1px solid #4caf50',
                color: '#2e7d32',
                padding: '12px 16px',
                borderRadius: '4px',
                marginBottom: '16px',
                fontSize: '14px',
                textAlign: 'center'
              }}>
                🌱 Development Account - No password required
              </div>
            )}

            {/* Server Field */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#555',
                marginBottom: '6px'
              }}>
                Server
              </label>
              <input
                type="text"
                value={credentials.server}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: '#f5f5f5',
                  fontSize: '14px',
                  color: '#888',
                  cursor: 'not-allowed'
                }}
                disabled
              />
            </div>

            {/* Connect Button */}
            <button
              type="submit"
              disabled={loading || !credentials.login || userAccounts.length === 0}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: loading || !credentials.login || userAccounts.length === 0 ? '#cccccc' : '#4caf50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: loading || !credentials.login || userAccounts.length === 0 ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (!e.target.disabled) {
                  e.target.style.backgroundColor = '#45a049';
                }
              }}
              onMouseOut={(e) => {
                if (!e.target.disabled) {
                  e.target.style.backgroundColor = '#4caf50';
                }
              }}
            >
              {loading ? 'Connecting...' : 'Connect to account'}
            </button>
          </form>

          {/* Create Account Link */}
          <div style={{ 
            textAlign: 'center',
            marginTop: '24px'
          }}>
            <button
              onClick={handleCreateAccount}
              style={{
                background: 'none',
                border: 'none',
                color: '#4285f4',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onMouseOver={(e) => e.target.style.color = '#3367d6'}
              onMouseOut={(e) => e.target.style.color = '#4285f4'}
            >
              Create Account
            </button>
          </div>

          {/* Back to Dashboard */}
          <div style={{ 
            textAlign: 'center',
            marginTop: '16px'
          }}>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: 'none',
                border: 'none',
                color: '#666',
                fontSize: '14px',
                cursor: 'pointer'
              }}
              onMouseOver={(e) => e.target.style.color = '#333'}
              onMouseOut={(e) => e.target.style.color = '#666'}
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTraderLogin;
